import styled from "styled-components";
import Grid from "@material-ui/core/Grid";

export const Nav = styled.div`
  box-sizing: border-box;
  height: 63px;
  border: 1px solid #ebebeb;
  border-radius: 3px;
  background-color: #ffffff;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.08);
  display: flex;
  align-items: center;

  .MuiContainer-root {
    text-align: left;
  }

  .state_logo:hover {
    cursor: pointer;
  }
`;

export const Wrapper = styled(Grid)`
  min-height: 100vh;
`;

export const SideNavSection = styled.div`
  background: #1c2125;
  position: fixed;
  height: 100vh;
  min-width: 250px;
  left: 0;
  top: 0;
  overflow-x: hidden;
  z-index: 100;
`;

export const Caption = styled.div`
  color: black;
  font-size: 21px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 28px;
  padding: 28.5px;
  padding-top: 16px;
  padding-bottom: 17px;
  border-bottom: 1px solid #ccd0d4;
`;
